import { render, staticRenderFns } from "./LoginCallback.vue?vue&type=template&id=59698ba8&scoped=true"
import script from "./LoginCallback.vue?vue&type=script&lang=ts"
export * from "./LoginCallback.vue?vue&type=script&lang=ts"
import style0 from "./LoginCallback.vue?vue&type=style&index=0&id=59698ba8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59698ba8",
  null
  
)

export default component.exports